import { mergeStyle } from "../../utils/constant";

function MergeTypeSetting({
  mergeSetting,
  setMergeSetting,
  setEnableSaveButton,
}) {
  return (
    <fieldset className="mg-b15">
      <legend>Merge Type</legend>
      <div className="row">
        <div className="col">
          <label className="custom-checkbox-label">
            <span className="custom-radio">
              <input
                name="MergeType"
                type="radio"
                value={mergeStyle.DATA_MERGE}
                checked={mergeSetting == mergeStyle.DATA_MERGE}
                onChange={(e) => {
                  setEnableSaveButton(true);
                  setMergeSetting(e.target.value);
                }}
                className=""
              />
              <span className="radiobox-check"></span>
            </span>
            Data Merge
          </label>
        </div>
        <div className="col">
          <label className="custom-checkbox-label">
            <span className="custom-radio">
              <input
                name="MergeType"
                type="radio"
                value={mergeStyle.XML_MERGE}
                checked={mergeSetting == mergeStyle.XML_MERGE}
                onChange={(e) => {
                  setEnableSaveButton(true);
                  setMergeSetting(e.target.value);
                }}
                className=""
              />
              <span className="radiobox-check"></span>
            </span>
            XML Merge
          </label>
        </div>
      </div>
    </fieldset>
  );
}

export default MergeTypeSetting;
